module.exports = __webpack_public_path__ + "static/media/man_han_sit_spe_met.1566bdd9.png";